<div class="modal__content paysafemodal">      
    <div class="modal__close" v-if="!isProcessing" @click="closeModal('paysafe')">
        <i class="fa-solid fa-xmark"></i>
    </div>
    <h1 class="center-section"  v-if="!isFinished">{{ $t('modals.paysafe.title') }} {{ currencyCode !== 'EUR' ? currencyCode : '' }}</h1>  
    <div class="finished" v-if="isFinished">
        <div class="failure" v-if="hasErrors">
            <h1 class="center-section">{{ $t('modals.paysafe.payment_failure')}}</h1>
            <div class="error center-section">
                <div class="error-title">
                    {{ $t('modals.paysafe.error-title') }}
                </div>
                <div class="error-content">
                    <i class="fa fa-warning"></i>{{ errors.message }}
                </div>                
            </div>
        </div>
        <div class="success" v-if="!hasErrors">            
            <h2 class="center-section">{{ $t('modals.paysafe.payment_succes')}}</h2>
            <div class="description center-section">
                   {{ $t('modals.paysafe.payment_succes_desc', {sec : CLOSE_TIMEOUT_SEC})}}
            </div>
            <div class="center-section">
                <button class="btn btn-small mr" @click="close()">{{ $t('modals.paysafe.close') }}</button>
            </div>                  
        </div>
    </div>
    <div class="processing" v-if="isProcessing">
        <div class="processing__content">
            {{ $t('modals.paysafe.processing') }}
        </div>
    </div>
    <div class="paysafemodal__content" v-if="!isFinished">   
        <form @submit="(ev, values) => onSubmit(ev, values)">
        <div class="row ">
            <div class="col summary">
                <span>{{ $t('modals.paysafe.description', {amount: $filters.shortCurrency(total, currencyCode), credits: $filters.niceCredits(credits + getBonus) } )  }}</span>
                <span class="bonus" v-if="getBonus">{{ $t('modals.paysafe.bonusdesc', {bonus: $filters.niceCredits(getBonus) }) }}</span>
            </div>   
        </div>
        <div class="card-information">
            <div class="row center-section">
                <div class="col info">{{ $t('modals.paysafe.cardInformation') }}</div> 
               
                <div class="col brands">
                    <span class="fa-cards fa-cards-visa"></span>
                    <span class="fa-cards fa-cards-master"></span>
                </div>
        
            </div>
            <div class="row">            
                <div class="col col-lg form-group">
                 
                    <label for="cardNumber">{{ $t('modals.paysafe.cardnumber') }}</label>
                    <div class="creditcard">
                        <div class="form-control card-number tabable" id="cardNumber" ref="cardNumber"> </div>
                        <span class="card-addon" ref="cardAddon"><i ref="ccIcon" class="fa fa-credit-card"></i></span>                    
                    </div>
                    <div class="explain">
                        {{ $t('modals.paysafe.cardnumber_explain') }}
                        <span class="test" v-if="isTesting && scenarioSelected">
                            {{ scenarioSelected.input.creditcard }}
                        </span>
                    </div>
                </div>
                <div class="col form-group">
                    <label for="cardExpiry">{{ $t('modals.paysafe.cardexpires') }}</label>
                    <div id="cardExpiry" class="form-control tabable" ref="cardExpiry"></div>
                    <div class="explain">{{ $t('modals.paysafe.cardexpires_explain') }}</div>
                </div>
                <div class="col col-sm form-group">
                    <label for="cardCVC">{{ $t('modals.paysafe.cardcvc') }}</label>
                    <div id="cardCVC" class="form-control" ref="cardCVC"></div>
                    <span class="test" v-if="isTesting && scenarioSelected?.input?.cvc">
                        {{ scenarioSelected.input.cvc }}
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col info">{{ $t('modals.paysafe.billingInformation') }}</div>
            </div>
            <div class="row">
                <div class="col form-group">
                    <label for="firstName">{{ $t('modals.paysafe.firstname') }}</label>
                    <div class="form-control" :class="{alert: errors.firstName  && activeValidation}">
                        <input type="text" v-model="firstName" id="firstName" maxlength="80" />
                        <div class="errorMessage" v-if="errors.firstname  && activeValidation"><span class="arrow"></span>
                            {{ $t(errors.firstName) }}</div>
                    </div>
                </div>
                <div class="col form-group">
                    <label for="lastName">{{ $t('modals.paysafe.lastname') }}</label>
                    <div class="form-control" :class="{alert: errors.lastName  && activeValidation}">
                        <input type="text" v-model="lastName" id="lastname" maxlength="80" />
                        <div class="errorMessage" v-if="errors.lastName  && activeValidation"><span class="arrow"></span>
                            {{ $t(errors.lastName) }}</div>
                    </div>
                </div>
            </div>
            <div class="row">      
                <div class="col form-group">
                    <label for="street">{{ $t('modals.paysafe.billingStreet') }}</label>
                    <div class="form-control" :class="{alert: errors.street && activeValidation}">
                        <input type="text" id="street" v-model="street" maxlength="50" />
                        <div class="errorMessage" v-if="errors.street && activeValidation">
                            <span class="arrow"></span>
                            {{ $t(errors.street) }}
                        </div>
                    </div>
                </div>
                <div class="col form-group">
                    <label for="zipcode">{{ $t('modals.paysafe.billingZip') }}</label>
                    <div class="form-control" :class="{alert: errors.zipcode  && activeValidation}">
                        <input type="text" v-model="zipcode" id="zipcode" maxlength="10" />
                        <div class="errorMessage" v-if="errors.zipcode  && activeValidation"><span class="arrow"></span>
                            {{ $t(errors.zipcode) }}</div>
                    </div>
                </div>   
            </div>
            <div class="row"> 
                <div class="col form-group" v-if="needsBillingInfo" >
                    <label for="state">{{ country.code !== 'US' && country.code !== 'CA' ? $t('modals.paysafe.billingState') : $t('modals.paysafe.billingStateUS')  }}</label>
                    <div class="form-control" v-if="country.code !== 'US' && country.code !== 'CA' ">
                        <input type="text" id="state" v-model="state" minlength="2" maxlength="40"
                            :class="{alert: errors.state  && activeValidation}" />
                        <div class="errorMessage" v-if="errors.state && activeValidation"><span class="arrow"></span>{{ $t(errors.state)
                            }}</div>
                    </div>
                    <div class="form-control" v-if="country.code == 'CA'">
                        <select v-model="stateCA">
                            <option value="AB">Alberta</option>
                            <option value="BC">British Columbia</option>
                            <option value="MB">Manitoba</option>
                            <option value="NB">New Brunswick</option>
                            <option value="NL">Newfoundland and Labrador</option>
                            <option value="NS">Nova Scotia</option>
                            <option value="ON">Ontario</option>
                            <option value="PE">Prince Edward Island</option>
                            <option value="QC">Quebec</option>
                            <option value="SK">Saskatchewan</option>
                            <option value="NT">Northwest Territories</option>
                            <option value="NU">Nunavut</option>
                            <option value="YT">Yukon</option>
                        </select>
                    </div>
                    <div class="form-control" v-if="country.code == 'US'">
                    
                        <select v-model="stateUS">
                            <option value="AL">Alabama</option>
                            <option value="AK">Alaska</option>
                            <option value="AZ">Arizona</option>
                            <option value="AR">Arkansas</option>
                            <option value="CA">California</option>
                            <option value="CO">Colorado</option>
                            <option value="CT">Connecticut</option>
                            <option value="DE">Delaware</option>
                            <option value="DC">District Of Columbia</option>
                            <option value="FL">Florida</option>
                            <option value="GA">Georgia</option>
                            <option value="HI">Hawaii</option>
                            <option value="ID">Idaho</option>
                            <option value="IL">Illinois</option>
                            <option value="IN">Indiana</option>
                            <option value="IA">Iowa</option>
                            <option value="KS">Kansas</option>
                            <option value="KY">Kentucky</option>
                            <option value="LA">Louisiana</option>
                            <option value="ME">Maine</option>
                            <option value="MD">Maryland</option>
                            <option value="MA">Massachusetts</option>
                            <option value="MI">Michigan</option>
                            <option value="MN">Minnesota</option>
                            <option value="MS">Mississippi</option>
                            <option value="MO">Missouri</option>
                            <option value="MT">Montana</option>
                            <option value="NE">Nebraska</option>
                            <option value="NV">Nevada</option>
                            <option value="NH">New Hampshire</option>
                            <option value="NJ">New Jersey</option>
                            <option value="NM">New Mexico</option>
                            <option value="NY">New York</option>
                            <option value="NC">North Carolina</option>
                            <option value="ND">North Dakota</option>
                            <option value="OH">Ohio</option>
                            <option value="OK">Oklahoma</option>
                            <option value="OR">Oregon</option>
                            <option value="PA">Pennsylvania</option>
                            <option value="RI">Rhode Island</option>
                            <option value="SC">South Carolina</option>
                            <option value="SD">South Dakota</option>
                            <option value="TN">Tennessee</option>
                            <option value="TX">Texas</option>
                            <option value="UT">Utah</option>
                            <option value="VT">Vermont</option>
                            <option value="VA">Virginia</option>
                            <option value="WA">Washington</option>
                            <option value="WV">West Virginia</option>
                            <option value="WI">Wisconsin</option>
                            <option value="WY">Wyoming</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row form-group">
                <div class="col form-group">
                    <label for="city">{{ $t('modals.paysafe.billingCity') }}</label>
                    <div class="form-control">
                        <input type="text" id="city" v-model="city" maxlength="40" :class="{alert: errors.city  && activeValidation}" />
                        <div class="errorMessage" v-if="errors.city && activeValidation"><span class="arrow"></span>{{ $t(errors.city)
                            }}</div>
                    </div>
                </div>
                <div class="col form-group">
                    <label for="country">{{ $t('modals.paysafe.billingCountry') }}</label>
                    <div class="form-control" :class="{alert: errors.country && activeValidation}">
                        <countryPicker :default="country" :options="countriesModel" tabindex="0"
                            @input="(country) => selectCountry(country)" @search-updated="(value) => filterCountry(value)">
                        </countryPicker>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col payinfo center-section">
                {{ $t('modals.paysafe.paymentstatement', { merchant: merchantName}) }}
            </div>
        </div>
        <div class="row">
            <div class="error" v-if="hasErrors" ><i class="fa fa-warning"></i>{{ errors.message }}</div>
        </div>
        <div class="row center-section">            
                <button id="payNow" type="submit" class="pay btn btn-info btn-lg btn-block" :disabled="!isFormValid"
                    :class="{'disabled': !isFormValid }">{{ $t('payment.paying') }}</button>                               
        </div>
        </form>
    </div>
</div>